import React from "react";

const MonthCarousel = ({ activeMonth, monthCarousel, onMonthChange }) => {
  const handlePrevMonth = () => {
    onMonthChange(Math.max(0, activeMonth - 1));
  };

  const handleNextMonth = () => {
    onMonthChange(Math.min(monthCarousel.length - 1, activeMonth + 1));
  };

  const formatMonthYear = (month, year) => {
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    return `${monthNames[month]}'${String(year).slice(2)}`;
  };

  return (
    <div className="month-carousel">
      <button 
        className="carousel-arrow prev"
        onClick={handlePrevMonth}
        disabled={activeMonth === 0}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      
      <div className="months-container">
        {monthCarousel.map((month, index) => (
          <div 
            key={`${month.month}-${month.year}`}
            className={`month-item ${index === activeMonth ? 'active' : ''}`}
            onClick={() => onMonthChange(index)}
          >
            {`Season ${index + 1} (${formatMonthYear(month.month, month.year)})`}
          </div>
        ))}
      </div>

      <button 
        className="carousel-arrow next"
        onClick={handleNextMonth}
        disabled={activeMonth === monthCarousel.length - 1}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
  );
};

export default MonthCarousel; 